
// Detail.js 로부터 진입

import PitureGround from './PictureGround';


export default props=>{
    if (!props.me) return <></>;
    return (<div className="">
        <style jsx>{`

.image-scroller{
    /* width: 350px; */
}

@media all and (max-width:606px) {
    .image-scroller{
        width: 100%;
    }
}

`}</style>
        <div className="dib image-scroller">
            {props.me.map((v, i) =>
                <div key={i} className="">
                    <PitureGround me={v} />
                </div>
            )}
        </div>
    </div>);
}